/**
 * Iletisim Sayfasi (B2C)
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Baby, Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const COMPANY_NAME = "KONSULTAN OZEL SAGLIK HIZMETLERI GIDA HAYV. TURZ. SAN. VE TIC. LTD. STI.";

const PatientContactPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <header className="bg-white/80 backdrop-blur border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex items-center gap-4">
          <Button data-testid="back-button" variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            Geri
          </Button>
          <div className="flex items-center gap-2">
            <Baby className="w-6 h-6 text-pink-500" />
            <span className="font-bold text-slate-800">BabyFace AI</span>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl shadow-sm border p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <MessageCircle className="w-8 h-8 text-pink-500" />
            <h1 data-testid="contact-title" className="text-2xl md:text-3xl font-bold text-slate-800">
              Iletisim
            </h1>
          </div>

          <p className="text-slate-600 mb-8">
            Sorulariniz, onerileriniz veya destek talepleriniz icin bize ulasabilirsiniz.
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-pink-50 rounded-xl p-6">
              <Mail className="w-8 h-8 text-pink-500 mb-3" />
              <h3 className="font-semibold text-slate-800 mb-1">E-posta</h3>
              <p className="text-sm text-slate-600">destek@babyface.ai</p>
              <p className="text-xs text-slate-400 mt-1">24 saat icinde yanitliyoruz</p>
            </div>

            <div className="bg-purple-50 rounded-xl p-6">
              <Phone className="w-8 h-8 text-purple-500 mb-3" />
              <h3 className="font-semibold text-slate-800 mb-1">Telefon</h3>
              <p className="text-sm text-slate-600">+90 (212) 000 00 00</p>
              <p className="text-xs text-slate-400 mt-1">Hafta ici 09:00 - 18:00</p>
            </div>

            <div className="bg-blue-50 rounded-xl p-6">
              <MapPin className="w-8 h-8 text-blue-500 mb-3" />
              <h3 className="font-semibold text-slate-800 mb-1">Adres</h3>
              <p className="text-sm text-slate-600">Istanbul, Turkiye</p>
            </div>

            <div className="bg-green-50 rounded-xl p-6">
              <MessageCircle className="w-8 h-8 text-green-500 mb-3" />
              <h3 className="font-semibold text-slate-800 mb-1">Canli Destek</h3>
              <p className="text-sm text-slate-600">Yakinda aktif olacak</p>
              <p className="text-xs text-slate-400 mt-1">WhatsApp destek hatti</p>
            </div>
          </div>

          <section className="bg-slate-50 rounded-lg p-4 mt-8">
            <p className="text-slate-600 text-sm">
              <strong>Unvan:</strong> {COMPANY_NAME}
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PatientContactPage;
